// Cosmetic motion of an already-confirmed server result. No RNG or wallet state.
import { WHEEL, validNumber } from './rouletteModel';
export const normalize = angle => (angle % 360 + 360) % 360;
export const pocketAngle = number => { if (!validNumber(number)) throw new Error('Invalid pocket'); return WHEEL.indexOf(number) * 360 / 37; };
export function spinPlan(fromRotor, fromBall, number) {
  if (![fromRotor,fromBall].every(Number.isFinite)) throw new Error('Invalid wheel pose');
  const rotor = fromRotor + 6 * 360 + 137.5, target = normalize(rotor + pocketAngle(number));
  const ball = fromBall - 8 * 360 - normalize(fromBall - target);
  return { rotor, ball, target };
}
export function showWheel({rotor,orbit,ball}, pose, number) {
  if (!rotor || !orbit || !ball) return;
  rotor.style.transform = `rotate(${normalize(pose.rotor)}deg)`;
  orbit.style.transform = `rotate(${normalize(pose.ball)}deg)`;
  ball.style.transform = `translate(-50%,-50%) translateY(-${184 * (orbit.clientWidth || 400) / 520}px)`;
  if (number != null) orbit.setAttribute('data-landed',String(number));
}
const abortError = () => new DOMException('Spin cancelled','AbortError');
const wait = (ms,signal) => new Promise((resolve,reject) => {
  let timer;
  const cancel = () => { clearTimeout(timer); reject(abortError()); };
  if (signal?.aborted) return cancel();
  signal?.addEventListener('abort',cancel,{once:true});
  timer = setTimeout(() => { signal?.removeEventListener('abort',cancel); resolve(); },ms);
});
export async function animateSpin(scene,from,number,{reduced=false,signal}={}) {
  if (signal?.aborted) throw abortError();
  const plan=spinPlan(from.rotor,from.ball,number),{rotor,orbit,ball}=scene;
  if (!rotor.animate) { await wait(250,signal); showWheel(scene,plan,number); return plan; }
  const options={duration:reduced?220:5200,fill:'forwards',easing:'linear'},scale=(orbit.clientWidth||400)/520;
  if (reduced) showWheel(scene,plan,number);
  const animations=reduced?[rotor.animate([{opacity:.55},{opacity:1}],options)]:[
    rotor.animate([{transform:`rotate(${from.rotor}deg)`},{transform:`rotate(${plan.rotor}deg)`}],{...options,easing:'cubic-bezier(.13,.5,.08,1)'}),
    orbit.animate([[0,0],[.2,.39],[.44,.73],[.65,.92],[.8,.987],[.9,1.002],[.96,.999],[1,1]].map(([offset,travel])=>({offset,transform:`rotate(${from.ball+(plan.ball-from.ball)*travel}deg)`})),options),
    ball.animate([[0,228],[.44,228],[.65,226],[.77,213],[.83,192],[.87,203],[.91,181],[.95,189],[1,184]].map(([offset,radius])=>({offset,transform:`translate(-50%,-50%) translateY(-${radius*scale}px)`})),options),
  ];
  const cancel=()=>animations.forEach(animation=>animation.cancel());
  signal?.addEventListener('abort',cancel,{once:true});
  try { await Promise.all(animations.map(animation=>animation.finished)); if(signal?.aborted)throw abortError(); showWheel(scene,plan,number); return plan; }
  finally { signal?.removeEventListener('abort',cancel); animations.forEach(animation=>animation.cancel()); }
}
